class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      body.classList.add('loading-end');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}